import { Component } from '@angular/core';

import { AgRendererComponent } from 'ag-grid-angular';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'vrm-mentor-activation-lnk',
  template: `
    <span class="error">
      {{ sendError ? sendError : '' }}
    </span>
    <span class="success">
      {{ sendSuccess ? sendSuccess : '' }}
    </span>
    <span>{{ !sendError ? firstLogin : '' }}</span>

    <button
      *ngIf="(isDriver === true || isManager === true) && !firstLogin && !sentYet"
      (click)="sendActivationMail()"
      style="color: white"
      [style.background-color]="'#' + cService.userProfile?.HqColour"
    >
      {{ 'SELFPROVISIONING.activationLnk' | translate }}
    </button>
  `,
  styles: [
    `
      button {
        border: 0px;
        padding: 4px;
        border-radius: 3px;
        cursor: pointer;
      }

      .error {
        color: red;
        font-size: 8px;
        text-transform: uppercase;
      }

      .success {
        color: blue;
        font-size: 8px;
        text-transform: uppercase;
      }
    `,
  ],
})
export class SendActivationMailComponent implements AgRendererComponent {
  firstLogin: string = null;
  sendError: string = null;
  sendSuccess: string = null;
  isDriver: boolean;
  isManager: boolean;
  params: any;
  sentYet: boolean;

  constructor(public cService: CommonService) {}

  agInit(params: any): void {
    this.setParams(params);
  }

  private setParams(params: any) {
    this.params = params;
    this.firstLogin = params.data.firstLogin;
    this.sendError = params.data.sendError;
    this.sendSuccess = params.data.sendSuccess;
    this.isDriver = params.data.isDriver;
    this.isManager = params.data.isManager;
    this.sentYet = params.data.sent;
  }

  sendActivationMail() {
    // Move up the process so it can controlled the result
    this.params.context.componentParent.triggerElementAction(this.params.data);
  }

  refresh(params: any): boolean {
    this.setParams(params);
    return true;
  }
}
